import Card from './Card';
import React from 'react';

export interface IPropsCard {
  title: string,
  list: IList[]
}

export interface IList {
  label: string
  value: string
}

const DataCard = (props: IPropsCard) => {
  return (
    <Card className="flex-1 px-4 py-3 border-solid border border-[#E5E5E7] rounded-xl">
      <Card.Header
        className="w-full pb-0 text-base font-semibold text-[#323539]"
        border={false}
      >
        {props.title}
      </Card.Header>
      <Card.Body className="mt-3">
        <div className="flex flex-col gap-2">
          {props.list.map((item, index) => (
            <div className="flex flex-row justify-between" key={index}>
              <div className="text-sm font-normal text-[#323539] md:whitespace-nowrap">{item.label}:</div>
              <div className="text-sm text-[#323539] self-stretch md:whitespace-nowrap font-semibold">{item.value}</div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  )
}

export default DataCard